import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_PROCESSOS_COLETIVOS = '/processosColetivos'

const actions = {
  async findById ({ commit }, id) {
    const data = await axios({
      method: 'get',
      url: `${modulo.ARRECADACAO}${URL_PROCESSOS_COLETIVOS}?id=${id}`
    })

    return data
  },

  async saveStep ({ commit }, {url, dados}) {
    const data = await axios({
      method: 'post',
      data: dados,
      url,
      error: true
    })

    return data
  },

  async find ({commit}, filtro) {
    const data = await axios({
      method: 'post',
      url: `${modulo.ARRECADACAO}${URL_PROCESSOS_COLETIVOS}/find`,
      data: filtro
    })
    return data
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/arrecadacao/processoColetivo.js